import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * ActiveCampaign Logo component
 *
 * @returns JSX.ELEMENT
 */
export const ActiveCampaignLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg id="active-campaign" viewBox="0 0 720 720" data-testid={dataTestId}>
      <rect fill="#4173b5" width="720" height="720" />
      <path
        fill="#fff"
        d="M512.3,388.57c11-7.64,14.23-17.67,14.23-27.28V357c0-10-5.53-17.81-14.25-24.07-7.37-5.29-274.62-191.09-274.62-191.09v39.53c0,13.73,7.44,18.31,16.78,24.9,13.45,9.5,222.14,154.4,222.14,154.4S265.13,506.82,252.49,515.23c-13.14,8.7-14.83,14.67-14.83,26.22v37S500.36,396.86,512.3,388.57Z"
        transform="translate(0 0)"
      />
      <path
        fill="#fff"
        d="M237.66,272.89v27.18s82.5,57.64,98.49,68.21c13.63,9,25.13,8.34,39-1.93,8.64-6.37,16.76-12,16.76-12S271.73,271,259.05,262.59C248.9,255.86,237.66,260.64,237.66,272.89Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};
